import { Component } from "react";
import RouteManager, { PAGE_ROUTES } from "../../managers/RouteManager";
import Stepper from "../common/Stepper";
import AppraisalCycleDetails from "./AppraisalCycleDetails";
import AppraisalCycleQuestions from "./AppraisalCycleQuestions";
import AppraisalCycleStepManager from "./AppraisalCycleStepManager";
import AppraisalManager from "./AppraisalManager";

export default class CreateAppraisalCycleStepper extends Component {
    steps = []
    
    stepperWidth = 200;
    constructor(props) {
        super(props);
        this.steps = AppraisalCycleStepManager.getAllCreationSteps(this.onStepClick);
        this.state = {
            currentStep: 0,
            count:0,
            currentStepData:null,
            appraisalData: AppraisalManager.getAppraisalData()
        }
    }
    componentDidMount() {
        RouteManager.setPresenter(this);
    }
    onStepClick = (index) => {
        if(index<this.state.currentStep) {
            this.setState({
                currentStep: index,
                count:0
            }) 
        } else {
            this.setState({
                count: this.state.count + 1
            }) 
        }
          
    }
    stepChange = (requiredStep, currentStepData) => {
        
        if(requiredStep < this.steps.length ) {
            this.setState({
                currentStep: requiredStep,
                count:0,
                currentStepData:currentStepData,
                appraisalData: requiredStep === 1 ?  currentStepData: this.state.appraisalData
            }) 
        }
        
    }
    onCancel = () => {
        AppraisalManager.setAppraisalData(null);
        RouteManager.navigateToPage(PAGE_ROUTES.APPRAISAL_CYCLE_LIST)
    }
    getCurrentStepChild=()=>{
        switch(this.state.currentStep) {
            case 0:
                return <AppraisalCycleDetails 
                            {...this.props} 
                            appraisalData={this.state.appraisalData}
                            count={this.state.count} 
                            onNext={(data)=>this.stepChange(1,data)} 
                            onCancel={()=>this.onCancel()}
                        />;
            case 1:
                return <AppraisalCycleQuestions 
                            {...this.props} 
                            data={this.state.currentStepData}
                            onNext={(data)=>this.stepChange(2,data)} 
                            onCancel={()=>this.onCancel()}
                            onBack={()=>this.onStepClick(this.state.currentStep - 1)}
                        />;
            default:
                return <></>
        }
    }
    render() {
        return<>
        <div className="column parent-width ">
          <Stepper
            data={this.steps}
            currentIndex={this.state.currentStep}
            className="mb-l"
            stepperType="EMPLOYEE_DEATILS"
            width={this.stepperWidth}
            currentStep={this.state.currentStep}
          />
          </div>
          <div className="m-v-xl row parent-width justify-content-start margin-empty-mobile">
            <div className="parent-width">{this.getCurrentStepChild()}</div>
          </div>
        </>
    }
}